/**
 * Formats a raw timestamp string into a standardized diagnostic format.
 * Expected output: "Apr 07 2026 8:20 PM"
 * 
 * @param {string} rawTimestamp - The raw timestamp string from the API.
 * @returns {string} - The formatted timestamp or a fallback ("--").
 */
export const formatDiagnosticDate = (rawTimestamp) => {
  if (!rawTimestamp) return "--";

  let dateString = rawTimestamp;
  
  // If the timestamp is a string and contains 'Z', strip it to avoid 
  // the browser adding a timezone offset (e.g., adding 5:30 hrs for IST).
  if (typeof dateString === 'string' && dateString.endsWith('Z')) {
    dateString = dateString.slice(0, -1);
  }

  // Try parsing the date. Some backend formats use spaces instead of 'T'.
  let date = new Date(dateString);
  
  // If parsing fails, try replacing space with 'T' for ISO compliance
  if (isNaN(date.getTime()) && typeof dateString === 'string') {
    date = new Date(dateString.replace(" ", "T"));
  }

  // Final check for validity
  if (isNaN(date.getTime())) return rawTimestamp || "--";

  const options = {
    month: "short",      // Dec
    day: "2-digit",      // 21
    year: "numeric",     // 2024
    hour: "numeric",     // 4
    minute: "2-digit",   // 30
    hour12: true         // PM
  };

  // Format using US locale for consistent MMM DD YYYY format
  return date.toLocaleString("en-US", options).replace(",", "");
};
